// Frontend metadata for each agent tool. Mirror of the TOOL_IDS list in
// `supabase/functions/agent-run/index.ts` — keep in sync.
import { Globe, FileText, Code2, ImageIcon, BookmarkPlus, type LucideIcon } from "lucide-react";

export type AgentToolId =
  | "web_search"
  | "web_fetch"
  | "code_exec"
  | "image_gen"
  | "save_to_library";

export const AGENT_TOOLS: {
  id: AgentToolId;
  label: string;
  description: string;
  icon: LucideIcon;
}[] = [
  {
    id: "web_search",
    label: "Web search",
    description: "Grounded search via Perplexity. Returns answer + citations.",
    icon: Globe,
  },
  {
    id: "web_fetch",
    label: "Web fetch",
    description: "Download a URL and read its text content.",
    icon: FileText,
  },
  {
    id: "code_exec",
    label: "Code exec (JS)",
    description: "Run JavaScript in a sandbox — math, parsing, transforms.",
    icon: Code2,
  },
  {
    id: "image_gen",
    label: "Image generation",
    description: "Produce an image as part of the agent's output.",
    icon: ImageIcon,
  },
  {
    id: "save_to_library",
    label: "Save to Library",
    description: "Persist the final artifact as a private library entry.",
    icon: BookmarkPlus,
  },
];

export const toolMeta = (id: string) => AGENT_TOOLS.find((t) => t.id === id);